<template>
  <v-container class="pa-0 d-flex flex-column gap-3">
    <!--  header --->
    <v-container class="pa-0 ma-0">
      <v-card-title class="pa-0 custom-title mb-2">{{ headerTitle }}</v-card-title>
      <v-card-text
        class="pa-0 text-body-2 grey--text text--darken-2"
        v-html="headerSubtitle"
      ></v-card-text>
    </v-container>

    <!--  register Steps --->
    <v-form ref="register" class="ma-0 pa-0">
      <!-- sing up --->
      <v-sheet v-if="register" class="pa-0 d-flex flex-column gap-3">
        <!--  phone number to register btn --->
        <v-container class="pa-0 ma-0 d-flex flex-column gap-3">
          <v-text-field
            v-model="phone"
            placeholder="0912-12xxxx7"
            outlined
            :label="$t('mobile')"
            class="rtl-text"
            clearable
            hide-details="auto"
            height="42"
            :rules="[mobileFormatRule]"
            @keydown.enter.prevent="sendOTPCode()"
          ></v-text-field>
          <v-btn
            :loading="loading"
            color="primary"
            small
            height="42"
            class="white--text"
            @click="sendOTPCode()"
          >
            {{ $t("register") }}
          </v-btn>
        </v-container>

        <!--  divider --->
        <v-container class="pa-0 ma-0 d-flex flex-column">
          <v-sheet class="d-flex align-center justify-center" color="transparent">
            <v-divider class="flex-grow-1"></v-divider>
            <v-card-subtitle class="pa-0 mx-4 grey--text text--darken-1 text-body-2">
              {{ $t("or") }}
            </v-card-subtitle>
            <v-divider class="flex-grow-1"></v-divider>
          </v-sheet>
        </v-container>

        <!--  return to login --->
        <v-container class="pa-0 ma-0 d-flex flex-column">
          <v-btn outlined color="primary" small height="42" @click="returnToLogin">
            {{ $t("log in") }}
          </v-btn>
        </v-container>
      </v-sheet>

      <!-- OTP --->
      <v-sheet v-if="OTPVerifyStep" class="pa-0 d-flex flex-column gap-3">
        <!-- set OTP code & resend --->
        <v-container class="pa-0 ma-0 d-flex flex-column gap-3">
          <v-text-field
            v-model="OTPcode"
            outlined
            :label="$t('send otp')"
            class="rtl-text"
            hide-details="auto"
            height="42"
            @keydown.enter.prevent="confirmOTP()"
          ></v-text-field>
          <v-row class="d-flex justify-space-between align-center" dense no-gutters>
            <v-col cols="auto">
              <v-card-text class="pa-0 grey--text text--darken-3 text-body-2">
                {{ $t("resend code again") }}
              </v-card-text>
            </v-col>
            <v-col cols="auto">
              <v-btn
                outlined
                color="primary"
                height="42"
                depressed
                :disabled="timer > 0"
                @click="resendOTP"
              >
                {{ otpButtonText }}
              </v-btn>
            </v-col>
          </v-row>
        </v-container>

        <!-- edit number --->
        <v-container class="pa-0 ma-0 d-flex flex-column gap-3">
          <v-row class="d-flex justify-space-between align-center" dense no-gutters>
            <v-col cols="auto">
              <v-card-text class="pa-0 grey--text text--darken-3 text-body-2">
                {{ $t("wrong number") }}
              </v-card-text>
            </v-col>
            <v-col cols="auto">
              <v-card-text
                class="pa-0 primary--text text-body-2"
                style="cursor: pointer"
                @click="EditPhone"
              >
                {{ $t("edit phone number") }}
              </v-card-text>
            </v-col>
          </v-row>
        </v-container>

        <!--confrim code --->
        <v-container class="pa-0 ma-0 d-flex flex-column gap-3">
          <v-btn
            :loading="loading"
            color="primary"
            small
            height="42"
            class="white--text"
            @click="confirmOTP()"
          >
            {{ $t("verify code") }}
          </v-btn>
        </v-container>
      </v-sheet>

      <!-- setRegisterPass --->
      <v-sheet v-if="setRegisterPassword" class="pa-0 d-flex flex-column gap-3">
        <!--set new pass and retype pass -->
        <v-container class="pa-0 ma-0 d-flex flex-column gap-3">
          <v-text-field
            v-model="password"
            outlined
            :label="$t('password')"
            class="rtl-text"
            hide-details="auto"
            clearable
            :rules="[passwordChecks]"
            height="42"
          ></v-text-field>
          <v-text-field
            v-model="retypePassword"
            outlined
            :label="$t('repeat password')"
            class="rtl-text"
            hide-details="auto"
            clearable
            height="42"
            @keydown.enter.prevent="confirmPassInfo()"
          ></v-text-field>
        </v-container>
        <!-- pass rules section -->
        <v-container class="pa-0 ma-0 d-flex flex-column gap-3">
          <div class="text-body-2">
            <div class="rule-line" :class="ruleClass(passwordChecks.length)">
              <v-icon x-small :color="iconColor(passwordChecks.length)">
                {{ iconName(passwordChecks.length) }}
              </v-icon>
              <v-card-text class="pa-0 m-0 text-body-2">
                {{ $t("min length 8") }}
              </v-card-text>
            </div>

            <div class="rule-line" :class="ruleClass(passwordChecks.upperLower)">
              <v-icon x-small :color="iconColor(passwordChecks.upperLower)">
                {{ iconName(passwordChecks.upperLower) }}
              </v-icon>
              <v-card-text class="pa-0 m-0 text-body-2">
                {{ $t("must include uppercase and lowercase") }}
              </v-card-text>
            </div>

            <div class="rule-line" :class="ruleClass(passwordChecks.number)">
              <v-icon x-small :color="iconColor(passwordChecks.number)">
                {{ iconName(passwordChecks.number) }}
              </v-icon>
              <v-card-text class="pa-0 m-0 text-body-2">
                {{ $t("must include number") }}
              </v-card-text>
            </div>

            <div class="rule-line" :class="ruleClass(passwordChecks.symbol)">
              <v-icon x-small :color="iconColor(passwordChecks.symbol)">
                {{ iconName(passwordChecks.symbol) }}
              </v-icon>
              <v-card-text class="pa-0 ma-0 text-body-2">
                {{ $t("must include symbol") }}
              </v-card-text>
            </div>
          </div>
        </v-container>

        <!-- confrim pass btn  -->
        <v-container class="pa-0 ma-0 d-flex flex-column gap-3">
          <v-btn
            color="primary"
            samll
            height="42"
            class="white--text"
            @click="confirmPassInfo()"
          >
            {{ $t("confirm password") }}
          </v-btn>
        </v-container>
      </v-sheet>

      <!-- setRegisterInfo --->
      <v-sheet v-if="setRegisterInfo" class="pa-0 d-flex flex-column gap-3">
        <v-container class="pa-0 ma-0 d-flex flex-column gap-3">
          <v-text-field
            v-model="name"
            outlined
            :label="$t('name')"
            class="rtl-text"
            hide-details="auto"
            clearable
            height="42"
          ></v-text-field>
          <v-text-field
            v-model="lastName"
            outlined
            :label="$t('last-name')"
            class="rtl-text"
            hide-details="auto"
            clearable
            height="42"
            @keydown.enter.prevent="confirmInformation()"
          ></v-text-field>
        </v-container>
        <v-container class="pa-0 ma-0 d-flex flex-column gap-3">
          <v-btn
            :loading="loading"
            color="primary"
            small
            height="42"
            class="white--text"
            @click="confirmInformation()"
          >
            {{ $t("save information") }}
          </v-btn>
        </v-container>
      </v-sheet>
    </v-form>

    <!--  footer --->
    <v-card-text class="pa-0 ma-0 text-center grey--text text--darken-1 text-body-2">
      {{ $t("login terms&condition") }}
      <a href="#" class="primary--text text-decoration-none">
        {{ $t("terms of use") }}
      </a>
      {{ $t("terms of service and policy") }}
      <a href="#" class="primary--text text-decoration-none">
        {{ $t("privacy policy half") }}
      </a>
      {{ $t("abriron is") }}
    </v-card-text>

    <!--  snackbar --->
    <v-snackbar
      v-model="snakbar"
      :color="snakbarColor ? snakbarColor : 'primary'"
      top
      style="z-index: 1000000000000 !important"
    >
      {{ snakbarText }}

      <template v-slot:action="{ attrs }">
        <v-btn
          :loading="loading"
          color="white"
          text
          v-bind="attrs"
          @click="snakbar = !snakbar"
        >
          {{ $t("close") }}
        </v-btn>
      </template>
    </v-snackbar>
  </v-container>
</template>

<script>
import General from "@/Mixins/general";
export default {
  name: "RegisterForm",
  mixins: [General],
  props: {
    signUpSection: Boolean,
  },
  data: () => ({
    phone: "",
    OTPcode: "",
    OTPtype: "loginByOtp",
    OTPtypeValidate: "validateOtp",
    password: "",
    retypePassword: "",
    name: "",
    lastName: "",
    register: true,
    OTPVerifyStep: false,
    setRegisterInfo: false,
    setRegisterPassword: false,
    mobileFormatRule: null,
    snakbar: false,
    snakbarColor: null,
    loading: false,
    snakbarText: null,
    timer: 120,
  }),
  created() {
    this.mobileFormatRule = (value) => {
      const regex = /^(\+98|0)?9\d{9}$/;
      return regex.test(value) ? true : this.$t("invalid mobile format");
    };
  },
  computed: {
    passwordChecks() {
      const pass = this.password || "";
      return {
        length: pass.length >= 8,
        upperLower: /[A-Z]/.test(pass) && /[a-z]/.test(pass),
        number: /\d/.test(pass),
        symbol: /[^A-Za-z0-9]/.test(pass),
      };
    },
    formattedTime() {
      const minutes = Math.floor(this.timer / 60);
      const seconds = this.timer % 60;
      return `${minutes.toString().padStart(2, "0")}:${seconds
        .toString()
        .padStart(2, "0")}`;
    },
    otpButtonText() {
      return this.timer > 0 ? this.formattedTime : this.$t("Resend");
    },
    headerTitle() {
      if (this.register) return this.$t("register");
      if (this.setRegisterInfo) return this.$t("initial information");
      if (this.setRegisterPassword) return this.$t("password");
      if (this.OTPVerifyStep) return this.$t("verify phone");
      return "";
    },
    headerSubtitle() {
      if (this.setRegisterInfo) return this.$t("enter initial information");
      if (this.setRegisterPassword) return this.$t("choose secure password");
      if (this.OTPVerifyStep) {
        return this.$t("verification code sent").replace(
          "<strong></strong>",
          `<strong>${this.phone}</strong>`
        );
      }
      return this.$t("welcome enter phone");
    },
  },
  methods: {
    ruleClass(isValid) {
      if (isValid) return "rule--valid";
      if (this.password.length > 0) return "rule--invalid";
      return "rule--neutral";
    },
    iconColor(isValid) {
      if (isValid) return "green";
      if (this.password.length > 0) return "red";
      return "grey";
    },
    iconName(isValid) {
      if (isValid) return "mdi-check";
      if (this.password.length > 0) return "mdi-close";
      return "mdi-circle";
    },
    returnToLogin() {
      this.$emit("update:signUpSection", false);
      this.$emit("switchMode", false);
    },
    startTimer() {
      this.timer = 120;
      const countdown = setInterval(() => {
        if (this.timer > 0) {
          this.timer--;
        } else {
          clearInterval(countdown);
        }
      }, 1000);
    },
    sendOTPCode() {
      var app = this;
      app.loading = true;
      const valid = this.mobileFormatRule(this.phone);
      if (valid !== true) {
        app.loading = false;
        return;
      }
      this.$axios
        .post(this.$apipoint + "v2/otp/send", {
          mobile: app.phone,
          password: app.password,
        })
        .then((response) => {
          this.OTPVerifyStep = true;
          this.register = false;
          this.startTimer();
        })
        .catch((err) => {
          app.loading = false;
          app.serverErrorHandeler(err);
        })
        .finally(() => {
          app.loading = false;
          app.overlay = false;
        });
    },
    EditPhone() {
      this.OTPVerifyStep = false;
      this.register = true;
    },
    confirmOTP() {
      var app = this;
      app.loading = true;
      this.$axios
        .post(this.$apipoint + "v2/otp/validate", {
          mobile: app.phone,
          code: app.OTPcode,
          type: app.OTPtypeValidate,
        })
        .then((response) => {
          if (response.data.meta.is_registered == false) {
            app.OTPVerifyStep = false;
            app.setRegisterPassword = true;
          } else {
            // localStorage.setItem('user', response.data.meta)
            // localStorage.setItem('hasaccount', response.data.meta.has_account)
            localStorage.setItem("usermobile", response.data.username);
            // localStorage.setItem("token", response.data.meta.token);
            localStorage.setItem(
              "primaryToken",
              JSON.stringify(response.data.meta.token)
            );
            app.$axios.defaults.headers.common.x_api_key = response.data.meta.token;
            localStorage.setItem("apn", null);
            if (response.data.meta.has_account == true) {
              // set (name + username + avatar) in vuex for showing user data
              app.$store.commit("SET_NAME", response.data.name);
              app.$store.commit(
                "SET_AVATAR",
                response.data.avatar ? response.data.avatar : null
              );
              app.$store.commit("SET_USERNAME", response.data.username);
              app.getAccount(response);
            } else {
              app.$router.push("/business-Info");
            }
          }
        })
        .catch((err) => {
          app.loading = false;
          app.serverErrorHandeler(err);
        })
        .finally(() => {
          app.loading = false;
          app.overlay = false;
        });
    },
    confirmPassInfo() {
      const { length, upperLower, number, symbol } = this.passwordChecks;
      if (length && upperLower && number && symbol) {
        if (this.password !== this.retypePassword) {
        } else {
          this.setRegisterPassword = false;
          this.setRegisterInfo = true;
        }
      } else {
        // console.log('is not valid')
      }
    },
    confirmInformation() {
      var app = this;
      app.loading = true;
      const lang = app.$root.$i18n.locale;
      this.$axios
        .post(this.$apipoint + "v2/register", {
          lang: lang,
          mobile: app.phone,
          firstname: app.name,
          lastname: app.lastName,
          password: app.password,
        })
        .then((response) => {
          // localStorage.setItem('user', response.data.meta)
          localStorage.setItem("usermobile", response.data.meta.user.username);
          // localStorage.setItem("token", response.data.meta.token);
          localStorage.setItem("primaryToken", JSON.stringify(response.data.meta.token));
          app.$axios.defaults.headers.common.x_api_key = response.data.meta.token;
          app.$router.push("/business-Info");
        })
        .catch((err) => {
          app.loading = false;
          app.serverErrorHandeler(err);
        })
        .finally(() => {
          app.loading = false;
          app.overlay = false;
        });
    },
    resendOTP() {
      var app = this;
      if (this.timer === 0) {
        app.sendOTPCode();
        app.startTimer();
      }
    },
    getAccount(value) {
      var app = this;
      app.loading = true;
      this.$axios
        .post(this.$apipoint + "v2/get-user-accounts", {
          headers: {
            x_api_key: value.data.meta.token,
          },
        })
        .then((response) => {
          this.$emit("business-selector", {
            hasAccount: value.data.meta.has_account,
            Authorization: value.data.meta.token,
            userData: response.data.accounts,
          });
        })
        .catch((err) => {
          app.loading = false;
          app.serverErrorHandeler(err);
        })
        .finally(() => {
          app.loading = false;
          app.overlay = false;
        });
    },
  },
};
</script>

<style scoped>
::v-deep .v-label {
  top: 10px !important;
}
::v-deep .v-label.v-label--active {
  top: 18px !important;
}
.v-text-field--enclosed .v-input__append-inner {
  margin-top: 10px;
}
.rule-line {
  display: flex;
  align-items: center;
  gap: 6px;
  transition: color 0.3s;
}
.rule--valid {
  color: #2e7d32;
}
.rule--invalid {
  color: #c62828;
}
.rule--neutral {
  color: gray;
}
.custom-title {
  font-weight: 600;
  font-size: 22px;
  line-height: 100%;
  letter-spacing: 0%;
  text-align: center;
  vertical-align: middle;
}
.v-text-field__details {
  margin: 0px;
  display: flex;
  flex: 1 0 auto;
}
</style>
